<div
  class="requestCard"
  [ngClass]="cardColour + ' ' + (actionOwner === activeFilter ? 'selected' : '')"
  (mouseenter)="viewHoverText = true"
  (mouseleave)="viewHoverText = false"
>
  <div>
    <h1>{{ value }}</h1>
    <p>{{ requestType }}</p>
  </div>
  <div *ngIf="viewHoverText" class="hoverTextContainer">
    <p class="viewP">VIEW</p>
  </div>
</div>
